import React from 'react';
import { BRAND_LIBRARY_DARK_TEXT_COLOR } from 'common/constants/brandLibrary';

import Headline from './PastSessionsHeadline.styles';

const PastSessionsHeadline = (props) => <Headline {...props} />;

PastSessionsHeadline.splash = {
    ...Headline.splash,
    defaultProps: {
        ...Headline.splash.defaultProps,
        styles: {
            ...Headline.splash.defaultProps.styles,
            fontColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
        },
        meta: {
            ...Headline.splash.defaultProps.meta,
            content: 'Past Sessions',
        },
    },
};

export default PastSessionsHeadline;
